<template>
    <div>
        <div class="modal fade" id="CourseOfUser" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 id="exampleModalLabel">
                            <strong><i class="fa-solid fa-chalkboard-user"></i> Danh sách khóa học hiện tại của học
                                viên</strong>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="text-danger"><i
                                    class="fa-regular fa-circle-xmark"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pb-2">
                        <div class="grant-permission-course">
                            <button type="button" data-toggle="modal" data-target="#GrantPermissionCourse" class="form-control btn btn-outline-success btn-sm col-3"><i class="fa-solid fa-plus"></i> Cấp quyền</button>
                        </div>
                        <div class="container-course">
                            <div v-if="isLoading" class="d-flex justify-content-center container-loader">
                                <flower-spinner class="loading-component" :animation-duration="2000" :size="30"
                                    color="#06C755" />
                            </div>
                            <div v-if="!isLoading">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Action</th>
                                            <th scope="col">Giá</th>
                                            <th scope="col">Tên khóa học</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(record, index) in records" :key="index">
                                            <th scope="row">{{ index + 1 }}</th>
                                            <td>
                                                <button data-toggle="modal" data-target="#RemovePermissionCourse" v-tippy
                                                    content="Xóa quyền của người dùng"
                                                    @click="selectPermissionCourse(record)">
                                                    <i class="fa-solid fa-user-minus"></i>
                                                </button>
                                            </td>
                                            <td class="text-danger"><strong>{{ this.$formatNumber(record.course_price)}}(VNĐ)</strong></td>
                                            <td>{{ record.course_name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RemovePermissionCourse :course_permission="course_permission"></RemovePermissionCourse>
        <GrantPermissionCourse :courses="courses" :user_id="user_id"></GrantPermissionCourse>
    </div>
</template>
<script>
import UserRequest from '@/restful/UserRequest';
import { FlowerSpinner } from 'epic-spinners';
import RemovePermissionCourse from '@/components/user/member-account/grant-permission/RemovePermissionCourse.vue'
import GrantPermissionCourse from '@/components/user/member-account/grant-permission/GrantPermissionCourse.vue'

export default {
    name: "CourseOfUser",
    components: {
        FlowerSpinner,
        RemovePermissionCourse,
        GrantPermissionCourse,
    },
    props: {
        courses: Array,
    },

    data() {
        return {
            isLoading: false,
            records: [],
            user_id: null,
            course_permission: null,
        }
    },
    mounted() {
        this.$onEvent('eventGetCourseOfUser', (user_id) => {
            this.resetData();
            this.user_id = user_id;
            this.getStudyLog(user_id);
        });
    },
    methods: {
        resetData: function () {
            this.isLoading = false;
            this.records = [];
        },
        getStudyLog: async function (user_id) {
            this.isLoading = true;
            try {
                const { data } = await UserRequest.get(`admin/management-user/get-list-course-of-user/${user_id}`);
                this.records = data;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }
        },
        selectPermissionCourse: function(record) {
            this.course_permission = {
                user_id: this.user_id,
                course_id: record.id,
                course_name: record.course_name,
            };
        },
    },
    watch: {

    }
}
</script>

<style scoped>
.modal-header .close {
    outline: none;
}

.modal-dialog {
    max-width: 80vw;
    margin: 10px auto;
}

.loading-component {
    margin: 50px 0px
}

.study-log-title {
    font-weight: bold;
}

.study-log-item {
    margin-left: 10px;
    list-style: square;
}

.view-more {
    border-radius: 20px;
}

.modal-body * {
    font-size: 16px;
}

.grant-permission-course {
    margin-bottom: 10px;
    display: flex;
    justify-content: end;
}

.container-course {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: scroll;
}

@media screen and (max-width: 1200px) {
    .modal-body * {
        font-size: 15px;
    }
}

@media screen and (max-width: 992px) {
    .modal-body * {
        font-size: 14px;
    }
}

@media screen and (max-width: 768px) {
    .modal-body * {
        font-size: 13px;
    }
}

@media screen and (max-width: 576px) {
    .modal-body * {
        font-size: 12px;
    }
}

@media screen and (max-width: 425px) {
    .modal-body * {
        font-size: 11px;
    }
}

@media screen and (max-width: 375px) {
    .modal-body * {
        font-size: 10px;
    }
}
</style>